// extracted by mini-css-extract-plugin
module.exports = {"chestIcon":"_cc3019b","iconContainer":"_33a69e3"};